interface InputProps {
  type: string;
  placeholder?: string;
  value?: string;
  onChange: (value: any) => void;
  className?: string;
  options?: { value: string; label: string }[];
  checked?: boolean;
  disabled?: boolean;
}

const Input = ({
  type,
  placeholder,
  value,
  onChange,
  className,
  options,
  checked,
  disabled,
}: InputProps) => {
  if (type === "select") {
    return (
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`w-full h-[38px] md:h-[6vh] px-6 bg-[#131313] rounded-[16px] border-[0.23vh] border-fourth-hover text-white placeholder-[#ffffff33] focus:border-[#00A3FF] focus:outline-none ${className ||
          ""}`}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }

  if (type === "checkbox") {
    return (
      <input
        type={type}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={`${className || ""}`}
        disabled={disabled}
      />
    );
  }

  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className={`w-full h-[38px] md:h-[6vh] px-6 bg-[#131313] rounded-[16px] border-[0.23vh] border-fourth-hover text-white placeholder-[#ffffff33] focus:border-[#00A3FF] focus:outline-none focus:border-transparent ${className ||
        ""}`}
    />
  );
};

export default Input;